'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M232 0l-8 0 0 16 80 0 0 192-80 0 0 16 160 0 0-16-64 0 0-208-88 0zM8 288l-8 0 0 16 80 0 0 192-80 0 0 16 160 0 0-16-64 0 0-208-88 0zM16 0l0 224 160 0 0-224-160 0zM32 16l128 0 0 192-128 0 0-192zM216 288l-8 0 0 224 160 0 0-224-152 0zm8 208l0-192 128 0 0 192-128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;